import React from "react";
import { useParams } from "react-router";
import { Toast } from "../UI/toast/Toast";
import { create } from "../../helpers/api/banks";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import PageHeader from "../common/PageHeader";
import SupportLink from "../root/support/components/SupportLink";
import CreatePeriodForm from "./CreatePeriodForm";
import { fetchCreatePeriod } from "../../helpers/api/finance";
import { confirmDuplicatePeriodDates } from "../../helpers/period/confirmDuplicatePeriodDates";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CreatePeriod = ({ setRedirectUrl, setRedirect }) => {
  const {
    condominium: { selectedCondominium },
  } = useSelector((state) => state);

  const history = useHistory();

  const submitPeriod = async (values) => {
    const response = await fetchCreatePeriod(selectedCondominium, values);

    if (response.code === SUCCESS_RESPONSE.SUCCESFUL) {
      history.push({
        pathname: `/dashboard/periods`,
      });

      Toast.fire({
        type: "success",
        title: "Se ha creado el período satisfactoriamente.",
      });
    }
  };

  const handleSubmitDataPeriod = async (values) => {
    try {
      await submitPeriod(values);
    } catch (error) {
      const handled = await confirmDuplicatePeriodDates(error, () =>
        submitPeriod({ ...values, confirm_duplicate_dates: true }).catch(handleErrorMessage)
      );
      if (!handled) handleErrorMessage(error);
    }
  };

  return (
    <>
      <PageHeader
        title="Crear nuevo período"
        titleTag="h2"
        description="Crea un nuevo periodo y gestionalo al instante."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <CreatePeriodForm
        handleSubmitData={handleSubmitDataPeriod}
        condominiumId={selectedCondominium}
      />
    </>
  );
};

export default withRedirect(CreatePeriod);
